import src from "IMAGE";
export default { src, width: 4447, height: 3213, blurWidth: 0, blurHeight: 0};
